import * as React from "react";
import { memo } from "react";
const SvgPickupTruck = (props) => (
  <svg
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={72} height={72} rx={36} fill="white" />
    <g clipPath="url(#clip0_598_518)">
      <path
        d="M46.6828 36.1701C49.1694 34.8132 50.8563 32.175 50.8563 29.1428C50.8563 24.7245 47.2746 21.1428 42.8563 21.1428C38.7234 21.1428 35.3225 24.2767 34.9004 28.2978"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9275 50.8571C26.3495 50.8571 25.0703 49.578 25.0703 48C25.0703 46.4219 26.3495 45.1428 27.9275 45.1428C29.5054 45.1428 30.7846 46.4219 30.7846 48C30.7846 49.578 29.5054 50.8571 27.9275 50.8571Z"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.3298 50.8571C36.7518 50.8571 35.4727 49.578 35.4727 48C35.4727 46.4219 36.7518 45.1428 38.3298 45.1428C39.9077 45.1428 41.1869 46.4219 41.1869 48C41.1869 49.578 39.9077 50.8571 38.3298 50.8571Z"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1426 38.8799H40.5711C41.7836 38.8799 42.9462 39.3615 43.8036 40.2188C44.661 41.0761 45.1426 42.2389 45.1426 43.4513V46.3085C45.1426 47.5709 44.1193 48.5942 42.8569 48.5942H41.1426"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1426 41.1428V35.9999C37.1426 35.3937 36.9018 34.8124 36.4731 34.3837C36.0445 33.9551 35.4631 33.7142 34.8569 33.7142H23.4283C22.8221 33.7142 22.2407 33.9551 21.812 34.3837C21.3834 34.8124 21.1426 35.3937 21.1426 35.9999V46.2857C21.1426 47.5481 22.1659 48.5714 23.4283 48.5714H25.1426"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7324 48.5714H35.5271"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8574 29.1425L45.1429 26.8572"
        stroke="black"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_598_518">
        <rect
          width={32}
          height={32}
          fill="white"
          transform="translate(20 20)"
        />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgPickupTruck);
export default Memo;

